import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { GET_WORKSTATION_POSITIONS_STATUS } from './actionTypes';
import { getWorkstationPositionsStatusSuccess, getWorkstationPositionsStatusError } from './actions';

// Include call API
import { getWorkstationsAPI } from '../../../api/workstations';

const workstationsAPI = getWorkstationsAPI();

function* getWorkstationPositionsStatus({ payload: { user } }) {
  try {
    const response = yield call(workstationsAPI.getPositionsStatus, user.token);
    yield put(getWorkstationPositionsStatusSuccess(response.positions, response.message));
  } catch (error) {
    yield put(getWorkstationPositionsStatusError(error));
  }
}

export function* watchGetWorkstationPositionsStatus() {
  yield takeEvery(GET_WORKSTATION_POSITIONS_STATUS, getWorkstationPositionsStatus);
}

function* getWorkstationPositionsStatusSaga() {
  yield all([fork(watchGetWorkstationPositionsStatus)]);
}

export default getWorkstationPositionsStatusSaga;
